import React from 'react';
import { ContentBlock, LogoWhite, SVGAnim } from './global';

export const Loading = React.memo(
    (props: {
        children?: any;
        ms?: number;
        disableTimer?: boolean;
        onLoaded?: () => void;
        inDiv?: boolean;
    }) => {
        const [loaded, setLoaded] = React.useState<0 | 1 | 2>(0);
        const [loadedImagesDone, setLoadedImagesDone] = React.useState(false);
        const blockRef = React.useRef<HTMLDivElement>(null);

        React.useEffect(() => {
            if (loaded === 2 && loadedImagesDone) {
                if (props.onLoaded) {
                    props.onLoaded();
                }
            }
        }, [loaded, loadedImagesDone]);

        React.useEffect(() => {
            const block = blockRef.current;

            if (block) {
                const images = block.querySelectorAll('img');
                const totalImages = images.length;
                let loadedImages = 0;

                const handleImageLoad = () => {
                    loadedImages++;

                    if (loadedImages === totalImages) {
                        // все изображения загружены
                        // console.log('Все изображения в блоке загружены');
                        setLoadedImagesDone(true);
                    }
                };

                images.forEach((image) => {
                    if (image.complete) {
                        handleImageLoad();
                    } else {
                        image.addEventListener('load', handleImageLoad);
                    }
                });
            }
        }, []);

        React.useEffect(() => {
            if (props.disableTimer) {
                return;
            }

            const tm2 = props.ms || 500;
            const tm1 = Math.floor(tm2 * 0.8);

            const int1 = setTimeout(() => {
                setLoaded(1);
            }, tm1);

            const int2 = setTimeout(() => {
                setLoaded(2);
            }, tm2);

            return () => {
                clearTimeout(int1);
                clearTimeout(int2);
            };
        }, [props.disableTimer]);

        return (
            <>
                <div
                    className={`loadingBlock ${props.inDiv ? 'inDiv' : ''} ${
                        loaded !== 0 && loadedImagesDone ? 'loaded' : ''
                    }`}
                >
                    {SVGAnim('material-loading')}
                    <img alt={'RocketMan'} id="loadingLogo" src={LogoWhite} />
                </div>
                <div
                    style={loaded !== 2 || !loadedImagesDone ? { display: 'none' } : undefined}
                    className={`loadingMain ${loaded && loadedImagesDone ? 'loaded' : ''}`}
                    ref={blockRef}
                >
                    {props.children}
                </div>
            </>
        );
    },
);
